// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import Formatter from '../../../i18n/formatter';
import { __, getCurrency } from '../../../i18n/l10n';
import colors from '../../../styled-components/palette';
import { BetslipTypes } from '../../../types/history';

const Summary = styled.div``;

const Item = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  color: ${colors.white};
  padding: 0 0.625em;
  margin-bottom: 0.3em;
  line-height: 1;
`;

const LabelStyled = styled.div`
  font-size: 0.8em;
`;

const ValueStyled = styled.div`
  font-size: 1.25em;
  font-weight: bold;
`;

const Winnings = styled(Item)``;

const WinningsValue = styled(ValueStyled)`
  color: ${colors.greenwinamax350};
`;

const Separator = styled.div`
  background: #424547;
  height: 1px;
  width: auto;
  margin: 0.625em;
`;

type HallOfFameItemSummaryProps = {
  className?: string;
  freebet?: boolean;
  betAmount: number;
  type: BetslipTypes;
  globalOdds?: number;
  details: Array<{ odds: number }>;
  winningsAmount: number;
  winningsBonus?: number;
  promotionTitle?: string;
};

const HallOfFameItemSummary = ({
  className = '',
  freebet,
  betAmount,
  type,
  globalOdds,
  details,
  winningsAmount,
  winningsBonus,
  promotionTitle,
}: HallOfFameItemSummaryProps) => {
  const isMultiple = type === BetslipTypes.MULTIPLE;

  return (
    <Summary className={className}>
      {isMultiple ? (
        <Item $isMultiple={isMultiple}>
          <LabelStyled>{__('Total odds')}</LabelStyled>
          <ValueStyled>
            {globalOdds
              ? Formatter.formatOdd(globalOdds)
              : Formatter.formatOdd(+details.reduce((prev, curr) => prev * curr.odds, 1))}
          </ValueStyled>
        </Item>
      ) : null}

      <Item $isMultiple={isMultiple}>
        <LabelStyled>{freebet ? __('Freebet Wager') : __('Wager')}</LabelStyled>
        <ValueStyled>{Formatter.formatNumber(betAmount, getCurrency())}</ValueStyled>
      </Item>

      <Separator />

      {promotionTitle && winningsBonus ? (
        <Item>
          <LabelStyled>
            {__('Winnings')} {promotionTitle}
          </LabelStyled>
          <ValueStyled>{Formatter.formatNumber(winningsBonus, getCurrency())}</ValueStyled>
        </Item>
      ) : null}

      <Winnings $isMultiple={isMultiple}>
        <LabelStyled>{__('Winnings')}</LabelStyled>
        {!isMultiple ? <>&nbsp;</> : null}
        <WinningsValue>{Formatter.formatNumber(winningsAmount + (winningsBonus || 0), getCurrency())}</WinningsValue>
      </Winnings>
    </Summary>
  );
};

export default HallOfFameItemSummary;
